import React, { Component } from 'react'

export default class Skill extends Component {
    render() {
        return (
            <div className=" col-6 col-md-4 skill text-center">
            <img className="skillLogo" src={this.props.img} alt={this.props.name}/>

        <p className="skillName">{this.props.name}</p>
        </div>
        )
    }
}
